module.exports = __webpack_public_path__ + "static/media/Sushi.55a01400.jpg";